<div class="billing-cycle page-b4a">
  <div class="billing-cycle__header">
    <div class="billing-cycle__title-row">
      <h1>Ciclo de Cobrança</h1>
      <i
        class="pi pi-question-circle billing-cycle__help"
        pTooltip="Attempt = onda do mês · PaymentRound = lote (TOP N) · Step = pipeline VALIDATION→FINISHED."
        tooltipPosition="right"
      ></i>
    </div>
    <p class="billing-cycle__subtitle">
      Attempt → Lote (PaymentRound) → Step. Enfileire ondas em lotes e acompanhe
      o que falta cobrar no mês.
    </p>
  </div>

  <section class="billing-cycle__month" *ngIf="monthSummary">
    <div class="billing-cycle__attempt-table">
      <h3>Por onda (Attempt)</h3>
      <p class="billing-cycle__table-hint">
        Taxa = pagos / (pagos + FAILED). Em voo não entra no denominador. Clique
        na onda para filtrar a tabela de steps.
      </p>
      <table *ngIf="visibleAttempts.length; else emptyAttempts">
        <thead>
          <tr>
            <th>Attempt</th>
            <th>Assinantes</th>
            <th>Em voo</th>
            <th>FAILED</th>
            <th>Pagos</th>
            <th>Aprovação</th>
            <th>Margem vs A1</th>
            <th>Sem cobrança</th>
            <th>Linhas Step</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let row of visibleAttempts"
            class="billing-cycle__attempt-row"
            [class.billing-cycle__attempt-row--active]="
              selectedAttempt === row.attempt
            "
            (click)="selectAttempt(row)"
          >
            <td>{{ row.attempt }}</td>
            <td>{{ formatNumber(row.distinctSubscribers) }}</td>
            <td>{{ formatNumber(row.inFlight) }}</td>
            <td>{{ formatNumber(row.failed) }}</td>
            <td>{{ formatNumber(row.paidPath) }}</td>
            <td>{{ formatApproval(row.approvalRatePercent) }}</td>
            <td>{{ formatMargin(row.marginVsAttempt1Pp) }}</td>
            <td>{{ formatNumber(row.neverChargedCount) }}</td>
            <td>{{ formatNumber(row.totalRows) }}</td>
          </tr>
        </tbody>
      </table>
      <ng-template #emptyAttempts>
        <p class="billing-cycle__empty">Nenhuma onda neste mês.</p>
      </ng-template>
    </div>
  </section>

  <section class="billing-cycle__enqueue">
    <header class="billing-cycle__section-header">
      <h2>Criar lote</h2>
      <span class="billing-cycle__section-hint"
        >EXEC StartPaymentRound &#64;BatchSize, &#64;Attempt, &#64;OnlyMonthly</span
      >
    </header>
    <div class="billing-cycle__enqueue-form">
      <div class="billing-cycle__field">
        <label for="enqueue-attempt">Attempt (onda)</label>
        <p-inputNumber
          inputId="enqueue-attempt"
          [(ngModel)]="enqueueAttempt"
          [min]="1"
          [showButtons]="true"
          (onBlur)="refreshMonthOnly()"
        />
      </div>
      <div class="billing-cycle__field">
        <label for="enqueue-batch">Batch size</label>
        <p-inputNumber
          inputId="enqueue-batch"
          [(ngModel)]="enqueueBatchSize"
          [min]="1"
          [max]="50000"
          [showButtons]="true"
          [step]="100"
        />
      </div>
      <div class="billing-cycle__field">
        <label for="enqueue-max">Max batches</label>
        <p-inputNumber
          inputId="enqueue-max"
          [(ngModel)]="enqueueMaxBatches"
          [min]="1"
          [max]="100"
          [showButtons]="true"
        />
      </div>
      <div class="billing-cycle__field billing-cycle__field--switch">
        <label for="enqueue-monthly">Só mensais</label>
        <p-inputSwitch inputId="enqueue-monthly" [(ngModel)]="enqueueOnlyMonthly" />
      </div>
      <div class="billing-cycle__field billing-cycle__field--action">
        <button
          pButton
          type="button"
          label="Enfileirar lote"
          icon="pi pi-play"
          [disabled]="isActionLoading"
          (click)="confirmEnqueue($event)"
        ></button>
      </div>
    </div>

    <div class="billing-cycle__lotes" *ngIf="lotes.length > 0">
      <h3>Lotes do mês</h3>
      <table>
        <thead>
          <tr>
            <th>PaymentRoundId</th>
            <th>Attempt</th>
            <th>Enqueued</th>
            <th>Assinantes</th>
            <th>VALIDATION</th>
            <th>PAYMENT</th>
            <th>FAILED</th>
            <th>PAID</th>
            <th>ACTIVATION</th>
            <th>SUBSCRIBER_EDITION</th>
            <th>FINISHED</th>
            <th>Executado</th>
            <th>User</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let lote of lotes">
            <td>{{ lote.paymentRoundId }}</td>
            <td>{{ lote.maxAttempt ?? '-' }}</td>
            <td>{{ formatNumber(lote.subscriberCount) }}</td>
            <td>{{ formatNumber(lote.distinctSubscribers) }}</td>
            <td>{{ formatNumber(lote.validationCount) }}</td>
            <td>{{ formatNumber(lote.paymentCount) }}</td>
            <td>{{ formatNumber(lote.failedCount) }}</td>
            <td>{{ formatNumber(lote.paidCount) }}</td>
            <td>{{ formatNumber(lote.activationCount) }}</td>
            <td>{{ formatNumber(lote.subscriberEditionCount) }}</td>
            <td>{{ formatNumber(lote.finishedCount) }}</td>
            <td>
              {{
                lote.dateExecuted
                  ? (lote.dateExecuted | date: 'dd/MM/yyyy HH:mm')
                  : '-'
              }}
            </td>
            <td>{{ lote.username || '-' }}</td>
            <td>
              <button
                pButton
                type="button"
                label="Filtrar steps"
                class="p-button-text p-button-sm"
                (click)="filterByLote(lote)"
              ></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <section class="billing-cycle__table">
    <h2>Subscriber Payment Step</h2>
    <p class="billing-cycle__table-hint">
      VALIDATION, PAYMENT, FAILED, PAID, ACTIVATION, SUBSCRIBER_EDITION,
      FINISHED.
    </p>
    <div class="billing-cycle__step-filters">
      <div class="billing-cycle__field">
        <label>Attempt</label>
        <p-inputNumber
          [(ngModel)]="filterAttempt"
          [min]="1"
          [showButtons]="true"
          placeholder="Todos"
        />
      </div>
      <div class="billing-cycle__field">
        <label>Lote (PaymentRoundId)</label>
        <p-inputNumber
          [(ngModel)]="filterPaymentRoundId"
          [min]="1"
          [showButtons]="false"
          placeholder="Todos"
        />
      </div>
      <div class="billing-cycle__field">
        <label>Step</label>
        <p-dropdown
          [options]="stepOptions"
          [(ngModel)]="filterStep"
          placeholder="Todos"
          [style]="{ minWidth: '12rem' }"
        />
      </div>
      <div class="billing-cycle__field billing-cycle__field--action">
        <button
          pButton
          type="button"
          label="Aplicar filtros"
          icon="pi pi-filter"
          class="p-button-outlined"
          (click)="applyStepFilters()"
        ></button>
      </div>
    </div>
    <app-table
      #stepsTable
      [lazy]="true"
      [findPage]="loadSteps"
      [service]="billingCycleService"
      [cols]="cols"
      [addButton]="false"
      [exportExcel]="false"
      [exportPdf]="false"
      [showTitle]="false"
      modelName="subscriber payment steps"
      sortField="dateUpdated"
      [sortOrder]="-1"
      [defaultRows]="20"
    />
  </section>

  <p-confirmPopup />
  <p-toast />
</div>
